export default __webpack_public_path__ + "static/media/73.a9c38b32.jpg";